import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { privilegesSelector } from 'features/user/selectors';

type RequireAnyPrivilegeProps = {
  requiredPrivileges: string[];
  redirectTo?: string;
  fallback?: React.ReactNode;
  throw404?: boolean;
} & React.PropsWithChildren;

export default function RequireAnyPrivilege({
  requiredPrivileges,
  redirectTo,
  fallback,
  throw404,
  children,
}: RequireAnyPrivilegeProps) {
  const privileges = useSelector(privilegesSelector);

  const hasAnyRequiredPrivileges: boolean = useMemo(() => {
    return requiredPrivileges.some((value) => privileges?.includes(value));
  }, [privileges, requiredPrivileges]);

  if (hasAnyRequiredPrivileges) {
    return <>{children}</>;
  }

  if (privileges !== undefined && redirectTo !== undefined) {
    return <Navigate to={redirectTo} replace />;
  }

  if (privileges !== undefined && fallback != undefined) {
    return <>{fallback}</>;
  }

  if (privileges !== undefined && throw404) {
    throw new Response('Not found', { status: 404 });
  }

  return <></>;
}
